import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useStore } from '@nanostores/react';
import { toast } from 'sonner';

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export function TcnModal({ open, setOpen }: Props) {
  // query client
  const queryClient = useQueryClient();
  const [apiKey, setApiKey] = useState('');
  const org = useStore($org);
  return (
    <Sheet
      open={open}
      onOpenChange={o => {
        setOpen(o);
      }}
    >
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Integrate Tcn</SheetTitle>
          <SheetDescription>
            Please provide your tcn api key
          </SheetDescription>
        </SheetHeader>

        <div className="mb-4 mt-4 grid grid-cols-3 gap-2">
          <div className="... col-span-2">
            <Input
              placeholder="xyz"
              value={apiKey}
              onChange={e => setApiKey(e.target.value)}
            />
          </div>
        </div>

        <SheetFooter>
          <SheetClose asChild>
            <Button variant="outline">Cancel</Button>
          </SheetClose>
          <Button
            onClick={async () => {
              const result = await createTcnApiKey(apiKey, org?.id ?? '');
              if (result?.error) {
                toast('An error occurred', {
                  description: result.error,
                  duration: 5000,
                });
              } else {
                // Invalidate the getOrgIntegrations query to trigger a refetch
                toast('Successfully created TCN API key', {
                  description: "success",
                  duration: 5000,
                });
                queryClient.invalidateQueries({ queryKey: ['getOrgIntegrations', org?.id] });
              }
              setOpen(false);
            }}
          >
            Submit
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}
